/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @version 1.0.0
 * @since 1.0.0
 */
import get from 'lodash/get';
import { createSelector } from 'reselect';
import { OutputSelector } from 'reselect/src';

import { IRootReducer } from '../../reducers/rootReducer';
import { initialPollingState } from './pollingReducer';
import { IPollingRequestParams, IPollingState } from './pollingTypes';

/**
 * Selector for receive polling state
 * @param {IRootReducer} state
 * @returns {IPollingState}
 */
export const getPollingState = (state: IRootReducer) => get(state, 'polling', initialPollingState);

/**
 * Selector for receive request params
 * @param {IRootReducer} state
 * @returns {IPollingState}
 */
export const makeSelectPollingRequesParams = (): OutputSelector<IRootReducer, IPollingRequestParams,
    (state: IPollingState) => IPollingRequestParams> =>
    createSelector(
        getPollingState,
        (state: IPollingState) => {
            return get(state, 'requestParams', initialPollingState.requestParams);
        },
    );

/**
 * Selector for receive response
 * @param {IRootReducer} state
 * @returns {IPollingState}
 */
export const makeSelectPollingResponse = (): OutputSelector<IRootReducer, unknown, (state: IPollingState) => unknown> =>
    createSelector(
        getPollingState,
        (state: IPollingState) => {
            return get(state, 'response', initialPollingState.response);
        },
    );

/**
 * Selector for receive polling result
 * @param {IRootReducer} state
 * @returns {IPollingState}
 */
export const makeSelectPollingResult = (): OutputSelector<IRootReducer, unknown, (state: IPollingState) => unknown> =>
    createSelector(
        getPollingState,
        (state: IPollingState) => {
            return get(state, 'result', initialPollingState.result);
        },
    );
